import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, TextInput } from '@mantine/core'
import { COLORS } from '../../utils/constants'

// Business name filter component
interface BusinessNameFilterProps {
  businessNameSearch: string
  setBusinessNameSearch: (value: string) => void
  triggerSearchWithFilters: (newFilters: any) => void
  currentFilters: any
  onFiltersChange: (newFilters: any) => void
}

const BusinessNameFilter = ({
  businessNameSearch,
  setBusinessNameSearch,
  triggerSearchWithFilters,
  currentFilters,
  onFiltersChange,
}: BusinessNameFilterProps) => {
  const handleSearch = () => {
    const updatedFilters = {
      ...currentFilters,
      businessName: businessNameSearch,
      currentPage: 1,
    }
    onFiltersChange(updatedFilters)
    triggerSearchWithFilters(updatedFilters)
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSearch()
    }
  }

  return (
    <Box
      style={{
        display: 'flex',
        alignItems: 'center',
        border: `1px solid ${COLORS.LightGreen}`,
        borderRadius: 30,
        padding: '0 4px 0 12px',
        minWidth: 220,
        maxWidth: 320,
        background: 'white',
      }}
    >
      <TextInput
        value={businessNameSearch}
        onChange={(e) => setBusinessNameSearch(e.currentTarget.value)}
        onKeyDown={handleKeyDown}
        placeholder='Search business name...'
        variant='unstyled'
        style={{ flex: 1, minWidth: 120 }}
      />
      {businessNameSearch && (
        <FontAwesomeIcon
          icon={faTimes}
          style={{ cursor: 'pointer', marginLeft: 8, fontSize: 16 }}
          onClick={() => {
            setBusinessNameSearch('')
            const updatedFilters = {
              ...currentFilters,
              businessName: '',
              currentPage: 1,
            }
            onFiltersChange(updatedFilters)
            triggerSearchWithFilters(updatedFilters)
          }}
        />
      )}
      <FontAwesomeIcon
        icon={faSearch}
        color='white'
        size='xs'
        onClick={handleSearch}
        style={{
          padding: 8,
          cursor: 'pointer',
          backgroundColor: COLORS.LightGreen,
          borderRadius: 30,
          marginLeft: 8,
        }}
      />
    </Box>
  )
}

export default BusinessNameFilter
